import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";

function Support() {
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    PTSupportID: 0,
    PTSupportTypeID: 0,
    SiteSessionID: 0,
    FirstName: "",
    LastName: "",
    Email: null,
    Phone: "",
    Subject: "",
    LastUpdatedTimestamp: "",
    Message: "",
    Resolved: "",
    Comments: "",
    FilesCount: "",
  });
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    getScreenListData();
    getScreenData();
  }, []);

  function getScreenListData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/PTSupport/PTSupportGetCompleteDataSetForForeignKeys"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;

          var l_arrTypes = [
            { PID: 1, Name: "Driver" },
            { PID: 2, Name: "Helper" },
          ];
          l_oResponse.push(l_arrTypes);

          var l_arrTiers = [
            { PID: 1, Name: "1" },
            { PID: 2, Name: "2" },
            { PID: 3, Name: "3" },
          ];
          l_oResponse.push(l_arrTiers);

          setScreenListData(l_oResponse);
        }
        // setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getScreenData() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL + "api/PTSupport/PTSupportGetCompleteGridDataCustom"
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "PTSupportID",
              selectedMoverID
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }


  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.PTSupportID = pid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MVLocations/MVLocationsDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getScreenData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  const [supportFiles, setSupportFiles] = useState<any[]>([]);
  const [ptFilesList, setPTFilesList] = useState<any[]>([]);

  const loadSupportFiles = async (PTSupportID: number) => {
    const data = {
      PTSupportID: PTSupportID,
    };

    try {
      const response = await axiosAuth.post(
        AppContext.APIURL + "api/PTSupport/LoadSupportFiles",
        data
      );

      const result = response.data.Data;
      const supportFiles = result[0] as any[];

      setSupportFiles(supportFiles);

      const updatedFiles = supportFiles.map((file) => {
        if (file.FileURL?.includes(";base64,/")) {
          return {
            ...file,
            FileURLDisplay: file.FileURL,
          };
        } else {
          return {
            ...file,
            FileURLDisplay: AppContext.GetFileIconToDisplay(file.FileURL),
          };
        }
      });

      setSupportFiles(updatedFiles);
      setPTFilesList([]); // same as your reset logic
    } catch (error) {
      console.error(error);
    }
  };

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "PTSupportTypeName")) {
        (
          document.getElementById(
            "imgSort" + "PTSupportTypeName"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "FirstName")) {
        (
          document.getElementById("imgSort" + "FirstName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "LastName")) {
        (
          document.getElementById("imgSort" + "LastName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              {/* <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      PTSupportID: 0,
                      PTSupportTypeID: 0,
                      SiteSessionID: 0,
                      FirstName: "",
                      LastName: "",
                      Email: null,
                      Phone: "",
                      Subject: "",
                      LastUpdatedTimestamp: "",
                      Message: "",
                      Resolved: "",
                      Comments: "",
                      FilesCount: "",
                    });
                    setIsAddNew(1);
                  }}
                >
                  Add New
                </a>
              </div> */}
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tbllocations", "Support")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tbllocations">
              <thead>
                <tr>
                  <th className="reuse-tdsm">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Support Type
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "PTSupportTypeName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("PTSupportTypeName")
                          }
                          title={"Sort By Support Type"}
                        >
                          <span id={"imgSort" + "PTSupportTypeName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        First Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "FirstName")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("FirstName")}
                          title={"Sort By First Name"}
                        >
                          <span id={"imgSort" + "FirstName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Last Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "LastName")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("LastName")}
                          title={"Sort By Last Name"}
                        >
                          <span id={"imgSort" + "LastName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Service Date</th>
                  <th>Submission Date</th>
                  <th>Message</th>
                  <th>Resolved</th>
                  <th>Comments</th>
                  <th>Files Count</th>
                  <th className="td-xxxs">Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.PTSupportTypeName}</td>
                          <td>{item.FirstName}</td>
                          <td>{item.LastName}</td>
                          <td>{item.Email}</td>
                          <td>{item.Phone}</td>
                          <td>{formateDate(item.Subject)}</td>
                          <td>{formateDate(item.LastUpdatedTimestamp)}</td>
                          <td>{item.Message}</td>
                          <td>{item.Resolved}</td>
                          <td>{item.Comments}</td>
                          <td>{item.FilesCount}</td>
                          <td className="td-xxxs">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  loadSupportFiles(item.PTSupportID);
                                  setAddEditObject({
                                    PTSupportID: item.PTSupportID,
                                    PTSupportTypeID: item.PTSupportTypeID,
                                    SiteSessionID: item.SiteSessionID,
                                    FirstName: item.FirstName,
                                    LastName: item.LastName,
                                    Email: item.Email,
                                    Phone: item.Phone,
                                    Subject: item.Subject,
                                    LastUpdatedTimestamp:
                                      item.LastUpdatedTimestamp,
                                    Message: item.Message,
                                    Resolved: item.Resolved,
                                    Comments: item.Comments,
                                    FilesCount: item.FilesCount,
                                  });
                                }}
                              >
                                <img
                                  src="images/eye-t.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Preview"
                                />
                              </a>
                              {/* <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.PTSupportID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Support Type:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.PTSupportTypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTSupportTypeID: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Other</option>
                  {screenListData[0] &&
                    screenListData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Site Session:
                </span>
                <input
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.SiteSessionID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SiteSessionID: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  First Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.FirstName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      FirstName: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Last Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.LastName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LastName: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Email:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Email}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Email: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Phone:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Phone}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Phone: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Subject:</span>
                <input
                  className="input-field w-100"
                  placeholder="Date"
                  type="date"
                  value={moment(addEditObject.Subject).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Subject: moment(e.target.value).format("YYYY-MM-DD"),
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Message:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.Message}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Message: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 flex-js text-left">
                <span className="font-12 text-left label-color">Resolved:</span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.Resolved}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Resolved: e.target.checked,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Comments:</span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.Comments}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Comments: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            {supportFiles.length > 0 && (
              <ul>
                {supportFiles.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      height: "auto",
                      width: "auto",
                      margin: "5px",
                      display: "inline-block",
                    }}
                  >
                    <a
                      href={item.FileURL}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        margin: "10px",
                        padding: 0,
                        border: "none",
                        minWidth: "10px",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={item.FileURLDisplay}
                        alt="img"
                        style={{
                          height: "100px",
                          width: "auto",
                        }}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            )}

            <div className="flex-daj gap-10 mt-20">
              {/* <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div> */}
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Close
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Support;
